import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { EMAIL_SNIPPETS_ACTION_TYPE } from '../actions';

const initialState = {
  activeSnippet: {},
  snippets: {},
};

const emailSnippetsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case EMAIL_SNIPPETS_ACTION_TYPE.SET_ACTIVE_SNIPPET:
        draft.activeSnippet = payload;
        break;

      case EMAIL_SNIPPETS_ACTION_TYPE.GET_EMAIL_SNIPPETS:
        draft.snippets = payload || state.snippets;
        break;

      case EMAIL_SNIPPETS_ACTION_TYPE.CREATE_EMAIL_SNIPPET:
      case EMAIL_SNIPPETS_ACTION_TYPE.UPDATE_EMAIL_SNIPPET:
        draft.snippets[payload.id] = payload;
        draft.activeSnippet = payload;
        break;

      case EMAIL_SNIPPETS_ACTION_TYPE.DELETE_EMAIL_SNIPPET:
        delete draft.snippets[meta.id];

        if (draft.activeSnippet.id === meta.id) {
          draft.activeSnippet = initialState.activeSnippet;
        }

        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default emailSnippetsReducer;
